import { styled } from '@mui/material/styles'
import Card from '@mui/material/Card'

const PREFIX = 'UnitCardStyle'
const classes = {
  root: `${PREFIX}-root`
}
const UnitCardStyle = styled(Card)(() => ({
  [`&.${classes.root}`]: {
    padding: 0,
    display: 'flex'
  }
}))

export {
  classes,
  UnitCardStyle
}
